import React, { FC } from 'react'
import classNames from 'classnames'
import { Text } from '@/atoms/Text'
import { useToggle } from '@/hooks/useToggle'

interface ExpandableDescriptionProps {
  text: string
  maxLength?: number
  className?: string
}

export const ExpandableDescription: FC<ExpandableDescriptionProps> = ({ text, maxLength = 100, className }) => {
  const [isExpanded, toggleIsExpanded] = useToggle(false)

  if (!text || text.length <= maxLength) {
    return (
      <Text className={classNames('photon-caption-sm lg:photon-caption-md block', className)} color="core-gray-400">
        {text}
      </Text>
    )
  }

  const truncatedText = isExpanded ? text : `${text.slice(0, maxLength)}...`

  return (
    <div className={className}>
      <Text className="photon-caption-sm lg:photon-caption-md block tracking-normal" color="core-gray-400">
        {isExpanded ? text : truncatedText}{' '}
        <span
          onClick={() => toggleIsExpanded()}
          className="!photon-caption-sm lg:!photon-caption-md inline cursor-pointer font-normal text-gray-400 underline hover:text-gray-300"
        >
          {isExpanded ? 'read less' : 'read more'}
        </span>
      </Text>
    </div>
  )
}
